import { whatsappUrl } from "@/utils/whatsapp";
import {
  WA_MESSAGES,
  SANDO_LOGO,
  SANDO_FOOTER_LINKS,
  SANDO_WHATSAPP_DISPLAY,
  SANDO_INSTAGRAM_HANDLE,
  SANDO_INSTAGRAM_URL,
  SANDO_ADDRESS,
} from "@/mocks/site";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-14 md:px-10 md:py-20">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-5">
            <img
              src={SANDO_LOGO}
              alt="Sando by Cerón"
              className="h-14 w-auto brightness-0 invert md:h-16"
            />
            <p className="mt-5 font-heading text-xl italic text-background-100">
              Tradición entre panes
            </p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200/80">
              Sandos de autor de la chef Diana Cerón. Servicio principalmente a domicilio en
              Armenia, Quindío.
            </p>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-lg text-background-50">Contacto</h3>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <a
                  href={whatsappUrl(WA_MESSAGES.general)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-background-100 transition-colors hover:text-primary-200"
                >
                  <i className="ri-whatsapp-line text-lg" aria-hidden="true" />
                  {SANDO_WHATSAPP_DISPLAY}
                </a>
              </li>
              <li>
                <a
                  href={SANDO_INSTAGRAM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-background-100 transition-colors hover:text-primary-200"
                >
                  <i className="ri-instagram-line text-lg" aria-hidden="true" />
                  {SANDO_INSTAGRAM_HANDLE}
                </a>
              </li>
              <li className="flex items-start gap-2 text-background-200/80">
                <i className="ri-map-pin-line mt-0.5 text-lg" aria-hidden="true" />
                <span>{SANDO_ADDRESS}</span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-heading text-lg text-background-50">Navegación</h3>
            <ul className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3 text-sm">
              {SANDO_FOOTER_LINKS.map((link) => (
                <li key={link.id}>
                  <a
                    href={link.href}
                    className="text-background-200/80 transition-colors hover:text-primary-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-200/60 sm:flex-row sm:items-center sm:justify-between">
          <p>Sando by Cerón · Armenia, Quindío</p>
          <p>Precios incluyen impuesto al consumo del 8%. Propina voluntaria (ley 1935 de 2018).</p>
        </div>
      </div>
    </footer>
  );
}